export default __webpack_public_path__ + "static/media/bg-wave.7f123006.png";